<template>
  <v-container fluid class="max-width">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Sales Order</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-btn color="primary" class="mt-2" small to="/new-sales-order">
            <v-icon left dark>mdi-plus</v-icon>Create Sales Order
          </v-btn>
        </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table :headers="headers" :items="recordsData" :search="search">
              <template v-slot:item.DocTotal="{ item }">
                <span>{{ item.DocTotal | currency}}</span>
              </template>

              <template v-slot:item.TotalTaxExc="{ item }">
                <span>{{ item.TotalTaxExc | currency}}</span>
              </template>

              <template v-slot:item.TotalTax="{ item }">
                <span>{{ item.TotalTax | currency}}</span>
              </template>


              <template v-slot:item.CreatedAt="{ item }">
                <span>{{ item.CreatedAt | date }}</span>
              </template>

              <template v-slot:item.action="{ item }">
                <v-btn text :to="`/sales-order/${item.id}`" color="accent">
                  <v-icon left>mdi-eye</v-icon> More Details
                </v-btn>
              </template>
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    date: new Date().toISOString().substr(0, 10),
    headers: [
      { text: "Doc No.", value: "DocNum" },
      { text: "Customer", value: "customer.Name" },
      { text: "Excl Total", value: "TotalTaxExc" },
      { text: "VAT", value: "TotalTax" },
      { text: "Incl Total", value: "DocTotal" },
      { text: "Date", value: "CreatedAt" },
      { text: "View Details", value: "action" },
    ],
    recordsData: [],
  }),
  methods: {
    getRecords() {
      let data = {};
      data.StartDate = this.date;
      const self = this;
      const url = `/sale-document-type/13`;
    this.$store.commit("loader", true);
      this.$store
        .dispatch("get", url)
        .then((res) => {
          if (res.ResultCode == 1200) {
           self.recordsData = res.ResponseData;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getRecords();
  },
};
</script>